document.addEventListener("DOMContentLoaded", function () {
  $(document).on("click", ".hc-collection-bundle", function (e) {
    e.preventDefault();
    $("body").addClass("addingproducts");

    const button = $(this);
    const productId = button.attr("data-product");
    const bundleWrapper = $('.hc-bundle-wrapper[data-product="' + productId + '"]');
    const activeItems = $('.hc-bundle-item.hc-bundle-active[data-product="' + productId + '"]');
    const isProductPage = $(".hc-product-bundle").length > 0;
  
    const originalText = button.find(".AddToCartText").text();
    button.find(".AddToCartText").text("Adding!");
    button.attr("disabled", true).addClass("is-loading");

    const items = [];

    activeItems.each(function () {
      const variant = $(this).attr("data-variant");
      if (variant) {
        let quantity = 1;
        if (isProductPage) {
          const qtyInput = $('input[name="quantity"]');
          if (qtyInput.length && parseInt(qtyInput.val()) > 0) {
            quantity = parseInt(qtyInput.val());
          }
        }
        items.push({ id: variant, quantity: quantity });
      }
    });

    if (items.length === 0) {
      alert("No items selected.");
      button.removeClass("is-loading").removeAttr("disabled").find(".AddToCartText").text(originalText);
      $("body").removeClass("addingproducts");
      return;
    }

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      contentType: "application/json",
      data: JSON.stringify({ items: items }),
      dataType: "json",
      success: function () {
        $("[data-drawer-body]").html(preLoadLoadGif);
        $("body")
          .find("[data-side-drawer]")
          .attr("class", "yv_side_drawer_wrapper")
          .attr("id", "mini__cart")
          .addClass("mini_cart");
        $("body").find("[data-drawer-title]").html(cartTitleLabel);
        $("body").addClass("side_Drawer_open");

        jQuery.getJSON(cartUrl, function (cart) {
          buildCart(cart, true);
          setTimeout(function () {
            button.removeClass("is-loading");
            button.find(".AddToCartText").text(originalText);
            $("body").removeClass("addingproducts");
            button.removeAttr("disabled");
          }, 1000);
        });

        const mainTitle = bundleWrapper.attr("data-main");
        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes: { Bundle: mainTitle } })
        });
      },
      error: function (error) {
        alert(error.responseJSON?.description || "Cart Error");
        button.removeClass("is-loading").removeAttr("disabled").find(".AddToCartText").text(originalText);
        $("body").removeClass("addingproducts");
      }
    });
  });

  $(document).on("click", ".se-product-trigger", function (e) {
    e.preventDefault();

    const wrapper = $(this).closest(".hc-collection-form-wrapper");
    const variantId = wrapper.find('input[name="id"]').val();

    if (!variantId) {
      alert("Variant not found.");
      return;
    }

    const button = $(this);
    const originalText = button.find(".product-quick-add").text();
    button.find(".product-quick-add").text("Adding!");
    button.attr("disabled", true).addClass("is-loading");

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: variantId
      },
      dataType: "json",
      success: function () {
        $("[data-drawer-body]").html(preLoadLoadGif);
        $("body")
          .find("[data-side-drawer]")
          .attr("class", "yv_side_drawer_wrapper")
          .attr("id", "mini__cart")
          .addClass("mini_cart");
        $("body").find("[data-drawer-title]").html(cartTitleLabel);
        $("body").addClass("side_Drawer_open");

        jQuery.getJSON(cartUrl, function (cart) {
          buildCart(cart, true);
          setTimeout(function () {
            button.removeClass("is-loading");
            button.find(".product-quick-add").text(originalText);
          }, 1000);
        });

        button.removeAttr("disabled");
      },
      error: function (error) {
        alert(error.responseJSON?.description || "Error adding product.");
        button.removeClass("is-loading").removeAttr("disabled");
        button.find(".product-quick-add").text(originalText);
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.hc-menu-main > a').forEach(function(anchor) {
    anchor.addEventListener('click', function(event) {
      const parentLi = anchor.closest('.hc-menu-main');
      const submenu = parentLi.querySelector('.hc-menu-level-2');

      if (submenu) {
        event.preventDefault();

        document.querySelectorAll('.hc-menu-level-2').forEach(function(menu) {
          if (menu !== submenu) {
            menu.style.display = 'none';
          }
        });

        submenu.style.display = submenu.style.display === 'block' ? 'none' : 'block';
      }
    });
  });

  document.querySelectorAll('.hc-menu-level-2 > li > a').forEach(function(anchor) {
    anchor.addEventListener('click', function(event) {
      const parentLi = anchor.parentElement;
      const submenu = parentLi.querySelector('.hc-menu-level-3');

      if (submenu) {
        event.preventDefault();

        parentLi.parentElement.querySelectorAll('.hc-menu-level-3').forEach(function(menu) {
          if (menu !== submenu) {
            menu.style.display = 'none';
          }
        });

        submenu.style.display = submenu.style.display === 'block' ? 'none' : 'block';
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const trigger = document.querySelector('.hc-mobile-filter-trigger');
  const close = document.querySelector('.hc-mobile-filter-close');
  const sidebar = document.querySelector('.yv-filter-sidebar');
  const body = document.body;

  if (trigger && sidebar) {
    trigger.addEventListener('click', function() {
      sidebar.classList.add('active');
      body.classList.add('open-filter-popup', 'open-filter-sort');
    });
  }

  if (close && sidebar) {
    close.addEventListener('click', function() {
      sidebar.classList.remove('active');
      body.classList.remove('open-filter-popup', 'open-filter-sort');
    });
  }
});

window.addEventListener('DOMContentLoaded', function () {
  const formSelect = document.querySelector('.select-form-type');
  const forms = {
    form1: document.querySelector('#form1'),
    form2: document.querySelector('#form2'),
    form3: document.querySelector('#form3')
  };

  function toggleForm() {
    const selected = formSelect.value;
    Object.entries(forms).forEach(([key, form]) => {
      form.classList.toggle('form-hidden', key !== selected);
    });
  }

  if (formSelect) {
    formSelect.addEventListener('change', toggleForm);
    toggleForm();
  }
});

document.querySelectorAll("ul.project-tabs li").forEach(function(tab) {
  tab.addEventListener("click", function() {
    var tab_id = this.getAttribute("data-tab");

    document.querySelectorAll("ul.project-tabs li").forEach(function(el) {
      el.classList.remove("current");
    });

    document.querySelectorAll(".project-tab-content").forEach(function(el) {
      el.classList.remove("current");
    });

    this.classList.add("current");
    document.getElementById(tab_id).classList.add("current");
  });
});

window.addEventListener("DOMContentLoaded", function () {
  if (typeof $.fn === "undefined" || typeof $.fn.slick !== "function") {
    return;
  }

  const $slider = $(".featured-product");

  if (!$slider.length) {
    return;
  }

  $slider.slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    focusOnSelect: true,
    prevArrow:
      '<button type="button" role="presentation" class="owl-prev"><button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M36.7,76.9c1.9,1.4,1.9,3.8,0,5.7c-0.6,0.6-1.6,0.9-2.8,0.9c-0.9,0-1.9-0.3-2.8-0.9L2.2,52.8 c-1.9-1.4-1.9-4.3,0-5.7L30,18.3c1.4-1.4,3.8-1.4,5.2,0c1.9,1.4,1.9,4.3,0,5.7L10.2,50L36.7,76.9z M95.2,46.2c1.9,0,3.8,1.9,3.8,4.3 c0,2.4-1.9,3.8-3.8,3.8H13c-2.4,0-3.8-1.4-3.8-3.8c0-2.4,1.4-4.3,3.8-4.3H95.2z" class="arrow"></path></svg></button></button>',
    nextArrow:
      '<button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M36.7,76.9c1.9,1.4,1.9,3.8,0,5.7c-0.6,0.6-1.6,0.9-2.8,0.9c-0.9,0-1.9-0.3-2.8-0.9L2.2,52.8 c-1.9-1.4-1.9-4.3,0-5.7L30,18.3c1.4-1.4,3.8-1.4,5.2,0c1.9,1.4,1.9,4.3,0,5.7L10.2,50L36.7,76.9z M95.2,46.2c1.9,0,3.8,1.9,3.8,4.3 c0,2.4-1.9,3.8-3.8,3.8H13c-2.4,0-3.8-1.4-3.8-3.8c0-2.4,1.4-4.3,3.8-4.3H95.2z" class="arrow" transform="translate(100, 100) rotate(180)"></path></svg></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
});

document.addEventListener('DOMContentLoaded', function() {
  var accordions = document.querySelectorAll('.yv-product-accordion.yv-faq-accordion');
  if (!accordions.length) return;

  accordions.forEach(function(accordion) {
    var headers = accordion.querySelectorAll('.yv-accordion-header');
    var contents = accordion.querySelectorAll('.yv-accordion-content');

    function closeAll() {
      contents.forEach(function(content) {
        content.classList.remove('is-open');
        content.style.display = 'none';
      });
      headers.forEach(function(header) {
        header.classList.remove('is-active');
        var vLine = header.querySelector('.v-line');
        if (vLine) vLine.style.display = 'block';
      });
    }

    function toggleItem(targetId) {
      var targetContent = null;
      contents.forEach(function(content) {
        if (content.id === targetId) targetContent = content;
      });
      if (!targetContent) return;

      var targetHeader = null;
      headers.forEach(function(header) {
        if (header.getAttribute('content') === targetId) targetHeader = header;
      });
      if (!targetHeader) return;

      var isOpen = targetContent.classList.contains('is-open');

      if (isOpen) {
        targetContent.classList.remove('is-open');
        targetContent.style.display = 'none';
        targetHeader.classList.remove('is-active');
        var vLineClose = targetHeader.querySelector('.v-line');
        if (vLineClose) vLineClose.style.display = 'block';
      } else {
        closeAll();
        targetContent.classList.add('is-open');
        targetContent.style.display = 'block';
        targetHeader.classList.add('is-active');
        var vLineOpen = targetHeader.querySelector('.v-line');
        if (vLineOpen) vLineOpen.style.display = 'none';
      }
    }

    headers.forEach(function(header) {
      header.addEventListener('click', function() {
        var targetId = header.getAttribute('content');
        if (!targetId) return;
        toggleItem(targetId);
      });
    });

    closeAll();
  });
});
